module.exports = __webpack_public_path__ + "static/media/hyper.7b5fcb92.png";